import { RoleModel } from 'types/models/RoleModel';
import { Role } from 'types/Project/Role';

export const mapRoleModeltoRoles = (roles: RoleModel[]): Role[] =>
  roles.map(({ id, name }) => ({
    name,
    id,
  }));
